export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5017.f64cc451.jpg";